import { Col, Row } from "antd";
import { CandidateFieldRenderer } from "common/components/candidateFieldRenderer/candidateFieldRenderer";
import { Section } from "../section";

export const CandidateFieldsSection = ({
  title,
  fields,
  context,
  extra,
  getUdfValue,
}) => (
  <Section title={title} extra={extra}>
    <Row gutter={[24, 16]}>
      {fields.map((field) => (
        <Col xs={24} sm={12} lg={field.span ?? 12} key={field.key}>
          <CandidateFieldRenderer
            field={field}
            context={context}
            getUdfValue={getUdfValue}
          />
        </Col>
      ))}
    </Row>
  </Section>
);
